import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import { CourseStatusSchema } from '@duke-hq/svc-api-db/schemas/enums/CourseStatus.schema';
import { SortOrder } from '@duke-hq/lib/pagination';

import CourseFilterBase from '../CourseFilterBase';

export default function CourseFilter({ maxSelected }: { maxSelected?: number }) {
  const { data } = trpcAdmin.courses.listCourses.useQuery(
    {
      filters: {
        status: [
          CourseStatusSchema.enum.PUBLISHED,
          CourseStatusSchema.enum.PENDING_SUPERSESSION,
          CourseStatusSchema.enum.SUPERSEDED,
        ],
        sort: SortOrder.ASC,
        orderBy: 'title',
      },
    },
    { initialData: [] },
  );

  return <CourseFilterBase data={data} maxSelected={maxSelected} />;
}
